/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Brandy(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224,88a95.63426,95.63426,0,0,0-15.53223-52.37207,7.99982,7.99982,0,0,0-6.70117-3.63086H54.2334A7.99954,7.99954,0,0,0,47.53223,35.627,96.014,96.014,0,0,0,120,183.66406V216H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V183.66406A96.127,96.127,0,0,0,224,88ZM58.70312,47.99707H197.29736A79.54855,79.54855,0,0,1,207.60205,80H48.398A79.53944,79.53944,0,0,1,58.70312,47.99707Z" />
    </Svg>
  );
}

export default Brandy;
